<script lang="ts">
  // components
  import AddDwollaPaymentInstrumentModal from "@retailer/svelte/Payments/AddDwollaPaymentInstrumentModal.svelte";
  import MicrodepositInformationModal from "@retailer/svelte/Payments/MicrodepositInformationModal.svelte";

  // types
  import type { PaymentInstrument } from "@shared/types/PaymentInstrument";

  // stores
  import { updatingBankAccount } from "@retailer/stores/BankAccountStore";

  // services
  import Spinner from "@shared/svelte/Components/Spinner.svelte";

  // props
  export let open: boolean = false;
  export let enteredMicrodepositFlow: boolean = false;
  export let onCloseModals: () => void;
  export let onSavePaymentInstrument: (paymentInstrument: PaymentInstrument) => void;
  let verificationStatuses: string[] = [];

  // data
  $: showMicrodepositModal = enteredMicrodepositFlow && !$updatingBankAccount && !open;

</script>

<div data-testid="add-payment-instrument-modal" />

{#if $updatingBankAccount}
  <Spinner />
{/if}

<AddDwollaPaymentInstrumentModal
  {open}
  bind:enteredMicrodepositFlow
  bind:verificationStatuses
  {onCloseModals}
  {onSavePaymentInstrument}
/>

<MicrodepositInformationModal {showMicrodepositModal} {verificationStatuses} />
